import React, { Component } from "react"
import { Col, Container, Row, Button } from "reactstrap"
import { withTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import i18n from 'i18next'
import { Trans } from 'react-i18next'
import { FaSearch } from "react-icons/fa"

class ResultatsFiableComplet extends Component {
  render() {
    const { t } = this.props
    const language = i18n.language ? (i18n.language.startsWith("fr") ? "fr" : i18n.language.startsWith("en") ? "en" : 'es') : undefined
    const langSubPath = language === "en" ? "/en" : language === "es" ? "/es" : ""

    return (
      <div className='gradiant-bot-gray px-3 px-md-0'>
        <Container className='py-5'>
          <Row className="justify-content-center">
            <Col md={9}>
              <h2 className='mb-5 text-left second-title dark-blue small-underline'>{t("home|Result-1")}</h2>
              <div className="text-justify">
                <p><Trans i18nKey="home|Result-2"/></p>
                <p><Trans i18nKey="home|Result-3"/></p>
                <p><Trans i18nKey="home|Result-4"/></p>
              </div>
              <p>{t("home|Result-5")}</p>
              <ul className="pl-5">
                <li><b>{t("home|Result-5-11")}</b> {t("home|Result-5-12")}</li>
                <li><b>{t("home|Result-5-21")}</b> {t("home|Result-5-22")}</li>
                <li><b>{t("home|Result-5-31")}</b> {t("home|Result-5-32")}</li>
              </ul>
              <div className="text-center mt-4 mb-3">
                <Link to={langSubPath + "/" + t("path|expertise-nahibu") + "/"}>
                  <Button className="btn-nah"><FaSearch className="fix-icon-pad mr-2"/>{t("home|Result-button")}</Button>
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default withTranslation()(ResultatsFiableComplet)
